module.exports = __webpack_public_path__ + "img/24_popup.79afdd56.png";